<template>
    <div :style="useMinHeight ? 'min-height:'+height+'px;' : ''">
        <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>
        <div v-if="!loading&&objectUrn" :style="{height:height+'px'}">
            <forge-vuer
                :getAccessToken="getToken"
                ref="forgevuer"
                @selection-changed-event="handleSelectionChange"
                @geometry-loaded-event="applySelection"
                @model-root-loaded-event="initialSetup"
                :urn="objectUrn"/>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import LoadingProgressBar from './../LoadingProgressBar'
import ForgeVuer from 'forge-vuer';

export default {
    props: {
        url: {type: String, default: null},
        height: {type: Number, default: 800},
        lightingPreset: {type: Number, default: null},
        selectedItems: {type: Array, default: null},
        highlightedItems: {type: Array, default: null},
        selectionColor: {type: String, default: null},
        nodeNamesToHide: {type: String, default: null},
        nodeNamesToRemove: {type: String, default: null},
        modeNameToFocus: {type: String, default: null},
        forcedBackground: {type: String, default: null},
        whiteMode:{type:Boolean, default: false},
        useMinHeight:{type:Boolean, default: false},
        groundShadow:{type:Boolean, default: false},
        groundReflection:{type:Boolean, default: false},
        lockNav:{type:Boolean, default: false},
    },
    components: {LoadingProgressBar, ForgeVuer},
    computed: {

    },
    name: 'ForgeViewerWidget',
    watch: {
        selectedItems(){
            this.applySelection()
        },
        highlightedItems(){
            this.applySelection()
        },
        url(){
            this.refresh()
        }
    },
    data: function () {
        return {
            loading: true,
            doneFirstFix: false,
            timeout: null,
            fitTimeout: null,
            objectUrn: null,
            animFrameId: null,
        }
    },
    mounted() {
        this.refresh()
    },
    beforeDestroy() {
        this.cleanupViewer();
        if (this.animFrameId) {
            cancelAnimationFrame(this.animFrameId);
            this.animFrameId = null;
        }
    },
    methods: {
        cleanupViewer() {
            if (this.$refs.forgevuer&&this.$refs.forgevuer.viewerService){
                const viewer = this.$refs.forgevuer.viewerService.Viewer3D;
                if (viewer) {
                    viewer.unloadModel(viewer.model);
                    viewer.finish();
                    this.$refs.forgevuer.viewerService.Viewer3D = null;
                }
            }

        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
        refresh() {
            this.debounce(this.reloadViewer, 500);
        },
        handleSelectionChange(eventData){
            this.$emit('select', eventData)
        },
        hexToRgb(hex) {
            const bigint = parseInt(hex.slice(1), 16);
            const r = (bigint >> 16) & 255;
            const g = (bigint >> 8) & 255;
            const b = bigint & 255;
            return [r, g, b];
        },
        resolveNodeIdsByName(nameToFocus) {
            if (!this.$refs.forgevuer || !this.$refs.forgevuer.viewerService) return [];
            const viewer3D = this.$refs.forgevuer.viewerService.Viewer3D;
            if (!viewer3D) return [];
            const model = viewer3D.model;
            const instanceTree = model && model.getData() ? model.getData().instanceTree : null;

            if (!instanceTree || !nameToFocus) {
                return [];
            }

            const matchedIds = [];
            const stack = [instanceTree.getRootId()];
            while (stack.length > 0) {
                const nodeId = stack.pop();
                if (instanceTree.getNodeName(nodeId) === nameToFocus) {
                    matchedIds.push(nodeId);
                }
                instanceTree.enumNodeChildren(nodeId, (childId) => {
                    stack.push(childId);
                }, false);
            }

            return matchedIds;
        },
        initialSetup(){
            this.$refs.forgevuer.viewerService.Viewer3D.setQualityLevel(true, true)
            this.$refs.forgevuer.viewerService.Viewer3D.setGroundShadow(this.groundShadow)
            this.$refs.forgevuer.viewerService.Viewer3D.setGroundReflection(this.groundReflection)
            if (this.whiteMode){
                this.$refs.forgevuer.viewerService.Viewer3D.setBackgroundColor(255,255,255,255,255,255)
            } else {
                this.$refs.forgevuer.viewerService.Viewer3D.setBackgroundColor(66,66,66,66,66,66)
            }
            if (this.lightingPreset||this.lightingPreset===0){
                this.$refs.forgevuer.viewerService.Viewer3D.setLightPreset(this.lightingPreset);
            }

            if (this.forcedBackground&&this.forcedBackground!==""){
                let [r, g, b] = this.hexToRgb(this.forcedBackground);
                this.$refs.forgevuer.viewerService.Viewer3D.setBackgroundColor(r, g, b, r, g, b);
            }
            if (this.lockNav){
                this.$refs.forgevuer.viewerService.Viewer3D.setNavigationLock(true);
            }
          let namesToRemove=this.nodeNamesToRemove ? this.nodeNamesToRemove.split(',') : []
          if (namesToRemove&&namesToRemove.length > 0) {
            for (let itemName of namesToRemove) {
              this.$refs.forgevuer.viewerService.Viewer3D.search(itemName, (dbIds) => {
                if (dbIds.length > 0) {
                  for (let dbId of dbIds) {
                    this.$refs.forgevuer.viewerService.Viewer3D.model.visibilityManager.setNodeOff(dbId, true);
                  }
                }
              }, null, ['name']);
            }
          }

            let namesToHide=this.nodeNamesToHide ? this.nodeNamesToHide.split(',') : []
            if (namesToHide&&namesToHide.length > 0) {
              for (let itemName of namesToHide) {
                this.$refs.forgevuer.viewerService.Viewer3D.search(itemName, (dbIds) => {
                  if (dbIds.length > 0) {
                    for (let dbId of dbIds) {
                      this.$refs.forgevuer.viewerService.Viewer3D.hide(dbId);
                    }
                  }
                }, null, ['name']);
              }
            }
          },
        applySelection(){
            if(!this.$refs.forgevuer) return
            const viewer3D = this.$refs.forgevuer.viewerService.Viewer3D
            const model = viewer3D.model
            if(this.selectedItems){
                const ids = this.selectedItems.map(id => { const n = parseInt(id, 10); return isNaN(n) ? id : n })
                viewer3D.setSelectionColor(this.selectionColor)
                viewer3D.select(ids, model)
                if(ids.length>0){
                    clearTimeout(this.fitTimeout)
                    const capturedIds = [...ids]
                    this.fitTimeout = setTimeout(() => {
                        if(this.$refs.forgevuer && this.$refs.forgevuer.viewerService){
                            const v3d = this.$refs.forgevuer.viewerService.Viewer3D
                            if(v3d && v3d.model) this.smoothFitToView(capturedIds, v3d)
                        }
                    }, 500)
                }
            }
            if(this.highlightedItems&&this.highlightedItems.length>0){
                const THREE3D = window.THREE || (Autodesk && Autodesk.Viewing && Autodesk.Viewing.Private && Autodesk.Viewing.Private.THREE)
                viewer3D.clearThemingColors(model)
                for(let item of this.highlightedItems){
                    const itemId = parseInt(item.id, 10)
                    const dbId = isNaN(itemId) ? item.id : itemId
                    const color = item.color ? new THREE3D.Vector4(item.color[0]/255, item.color[1]/255, item.color[2]/255, 0.7) : new THREE3D.Vector4(61/255, 220/255, 132/255, 0.7)
                    viewer3D.setThemingColor(dbId, color, model)
                }
            }
            if (!this.doneFirstFix&&this.modeNameToFocus&&this.modeNameToFocus!=="" ){
                let nameToFocus=this.modeNameToFocus
                if(nameToFocus){
                  let viewer3D=this.$refs.forgevuer.viewerService.Viewer3D
                                    const matchedIds = this.resolveNodeIdsByName(nameToFocus)
                                    if (matchedIds.length > 0){
                                        this.smoothFitToView(matchedIds, viewer3D)
                                    }
                }
                this.doneFirstFix=true
            }

        },
        smoothFitToView(ids, viewer) {
            // Cancel any ongoing camera animation
            if (this.animFrameId) {
                cancelAnimationFrame(this.animFrameId);
                this.animFrameId = null;
            }

            const THREE3D = window.THREE ||
                (window.Autodesk && Autodesk.Viewing &&
                    Autodesk.Viewing.Private && Autodesk.Viewing.Private.THREE);
            const model = viewer.model;
            if (!THREE3D || !model) {
                viewer.fitToView(ids, model);
                return;
            }

            // Compute world bounding box for the target nodes
            const bounds = new THREE3D.Box3();
            try {
                const tree = model.getData().instanceTree;
                const frags = model.getFragmentList();
                for (const dbId of ids) {
                    tree.enumNodeFragments(dbId, (fragId) => {
                        const box = new THREE3D.Box3();
                        frags.getWorldBounds(fragId, box);
                        if (!box.isEmpty()) bounds.union(box);
                    }, true);
                }
            } catch (e) {
                viewer.fitToView(ids, model);
                return;
            }

            if (bounds.isEmpty()) {
                viewer.fitToView(ids, model);
                return;
            }

            const nav = viewer.navigation;
            const startPos = nav.getPosition().clone();
            const startTarget = nav.getTarget().clone();

            // Use the viewer's own computeFit to get the exact target camera state,
            // matching what fitToView would compute but without causing a visual jump.
            const fov = viewer.impl.camera.fov;
            const aspect = viewer.impl.camera.aspect;
            const fit = nav.computeFit(startPos, startTarget, fov, bounds, aspect);
            if (!fit) {
                viewer.fitToView(ids, model);
                return;
            }
            const endPos = fit.position;
            const endTarget = fit.target;

            // Animate over 5 s with ease-in-out cubic
            const duration = 5000;
            const startTime = performance.now();
            const easeInOutCubic = (t) =>
                t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

            const animate = (timestamp) => {
                const t = Math.min((timestamp - startTime) / duration, 1);
                const ease = easeInOutCubic(t);

                const pos = new THREE3D.Vector3().lerpVectors(startPos, endPos, ease);
                const tgt = new THREE3D.Vector3().lerpVectors(startTarget, endTarget, ease);

                nav.setView(pos, tgt);
                viewer.impl.invalidate(true);

                if (t < 1) {
                    this.animFrameId = requestAnimationFrame(animate);
                } else {
                    this.animFrameId = null;
                }
            };

            this.animFrameId = requestAnimationFrame(animate);
        },
        async getToken(onSuccess) {
            let proxyUrl = `https://proxy3d-46951823311.asia-east2.run.app/?targetUrl=${encodeURIComponent(this.url.replace('public', 'sign').replace('mode=embed', 'oauth2=true'))}`;
            axios.post(
                //this.url.replace('public', 'sign').replace('mode=embed', 'oauth2=true'), {}, {overrideCarnotAuth:true}
                proxyUrl, {}, {overrideCarnotAuth: true}
            )
                .then(response => {
                    onSuccess(response.data.accessToken, response.data.validitySeconds);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        async reloadViewer() {
            if (this.url && this.url !== "") {
                let me = this
                me.loading = true

                let proxyUrl = `https://proxy3d-46951823311.asia-east2.run.app/?targetUrl=${encodeURIComponent(this.url.replace('public', 'metadata').replace('mode=embed', ''))}`;
                //let urnResponse = await axios.get(this.url.replace('public', 'metadata').replace('mode=embed', ''),{overrideCarnotAuth:true})
                let urnResponse = await axios.get(proxyUrl, {overrideCarnotAuth:true})
                me.doneFirstFix = false
                me.objectUrn=urnResponse.data.success.body.viewing.views.viewableUrn
                me.loading = false
            }
        }
    },

}

</script>

<style scoped>

</style>
